import React from 'react';
import {asArray, evaluateFunction, OmitStrict} from '@wix/devzai-utils-common';
import {useIsWidgetInFixedHeight} from '../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context';
import {
    DoppeActionTypeWidgetContentLayoutNewSectionsAndButtons
} from '../doppe-action-type-widget-content-layout-new-sections-and-buttons/doppe-action-type-widget-content-layout-new-sections-and-buttons';
import {BymoPageActionMediaViewLayout, BymoPageMedia} from '../../client-server-common';
import {DoppePageActionMediaView} from '../doppe-page-action-media-view/doppe-page-action-media-view';
import {DoppeActionMediaViewSettings} from '../../client-server-common/types/doppe-action-media-view-settings';

export const DoppeActionTypeWidgetContentLayoutWrapper2 = React.memo(function DoppeActionTypeWidgetContentLayoutWrapper2 (props: DoppeActionTypeWidgetContentLayoutWrapper2.Props) {

    const {
        media,
        mainMediaViewLayout,
        mainMediaViewSettings,
        ...restProps
    } = props;

    const isWidgetInFixedHeight = useIsWidgetInFixedHeight();

    const fullWidthMainMedia = evaluateFunction(() => {
        switch (mainMediaViewLayout) {
            case BymoPageActionMediaViewLayout.FullWidth: {
                return true;
            }
            case BymoPageActionMediaViewLayout.WithMargins: {
                return false
            }
        }
    });

    const mainMedia = asArray(media)[0] ? (
        <DoppePageActionMediaView
            mediaResource={asArray(media)[0]}
            mediaViewSettings={mainMediaViewSettings}
            widthSpec={{contentRelativeWidth: 1}}
        />
    ) : null;

    return (
        <DoppeActionTypeWidgetContentLayoutNewSectionsAndButtons
            {...restProps}
            mainMedia={mainMedia}
            isFixedHeight={isWidgetInFixedHeight}
            fullWidthMainMedia={fullWidthMainMedia}
        />
    );
});

export namespace DoppeActionTypeWidgetContentLayoutWrapper2 {

    export interface Props extends
        OmitStrict<DoppeActionTypeWidgetContentLayoutNewSectionsAndButtons.Props, 'isFixedHeight' | 'mainMedia' | 'fullWidthMainMedia'>,
        DoppeActionMediaViewSettings {
        media: BymoPageMedia[] | null;
    }
}
